<template>
  <div class="checkbox">
    <label>
      <input ref="input" v-bind="$attrs" :type="type" :value="value" @input="$emit('input', $event.target.value)">&nbsp;
      <slot>{{ label }}</slot>
    </label>
  </div>
</template>

<script>
export default {
  name: "CCheckbox",
  props: {
    value: [Object, String, Boolean],
    label: String,
    type: {
      type: String,
      default: 'checkbox'
    }
  },
  mounted() {
    $(this.$refs.input).iCheck({
      checkboxClass: 'icheckbox_square-green',
      radioClass: 'iradio_square-green',
      increaseArea: '20%' // optional
    });
  }
}
</script>

<style scoped>

</style>